import React, { createContext, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { API } from '../services';
import { secureStorage } from '../utilities/securityUtils';

export const ApiLinksContext = createContext(null);

export const ApiLinksProvider = ({ children }) => {
  const fetchLinks = async () => {
    try {
      const { data } = await API.getApiLinks();
      secureStorage.setItem('api-links', JSON.stringify(data));
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Failed to load API links:', err);
    }
  };

  const contextValue = useMemo(
    () => ({
      fetchLinks,
    }),
    []
  );

  return (
    <ApiLinksContext.Provider value={contextValue}>
      {children}
    </ApiLinksContext.Provider>
  );
};

ApiLinksProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useApiLinks = () => useContext(ApiLinksContext);
